"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventCancellationSchema = void 0;
exports.EventCancellationSchema = {
    type: 'object',
    required: ['email_campaign_id'],
    additionalProperties: false,
    properties: {
        email_campaign_id: {
            type: [
                'string',
                'null',
            ],
        },
        stage_name: {
            type: 'string',
        },
        next_workflow_ids: {
            type: 'object',
            properties: {},
        },
    },
};
